export default __webpack_public_path__ + "static/media/RotasCaminho.87c8513e.svg";